import React from 'react'
import { HistoryCommit } from 'components/molecules'
import { Text, Spacer } from 'components/atoms'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { statusType } from 'types'

const HistoryCommitList = ({
  title,
  list,
  isLoading,
}) => (
  <CommitList>
    {(title && !isLoading) && (
      <>
        <Text modifiers={['l']}>{title}</Text>
        <Spacer bottom="xs2" />
      </>
    )}
    {isLoading ? (
      <>
        <Spacer top="xs3" />
        <HistoryCommit isLoading date={new Date().toISOString()} />
        <HistoryCommit isLoading date={new Date().toISOString()} />
      </>
    ) : (
      list.map(commit => (
        <HistoryCommit {...commit} key={commit.id} />
      ))
    )}
  </CommitList>
)

const CommitList = styled.div`

`

HistoryCommitList.propTypes = {
  title: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    date: PropTypes.string.isRequired,
    user: PropTypes.shape({
      name: PropTypes.string.isRequired,
      image: PropTypes.string,
    }).isRequired,
    actions: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.string,
      description: PropTypes.string,
      status: statusType
    })).isRequired,
    onContact: PropTypes.func,
    onPreview: PropTypes.func,
  })),
  isLoading: PropTypes.bool,
}

HistoryCommitList.defaultProps = {
  title: null,
  list: [],
  isLoading: false,
}

export default HistoryCommitList
